import { Injectable } from '@angular/core';
import { Screen } from '.';

export interface ImgSource {
  media: Screen;
  srcset: string;
}

export const screenImageWidths = {
  XS: 320,
  SM: 768,
  MD: 1024,
  LG: 1366,
  XL: 1920,
};

export type ImgQuery = Record<keyof typeof Screen, number | { width?: number; url?: string }>;

@Injectable({
  providedIn: 'root',
})
export class PictureService {
  constructor() {}

  public getImgSourcesForMpxImage(imageUrl: string, imgQuery?: ImgQuery, imgParam?: string): ImgSource[] {
    return Object.keys(Screen).map((size) => {
      const media = Screen[size];
      const isImageWidthSpecified = imgQuery && (imgQuery[size]?.width || !isNaN(imgQuery[size]));
      const defaultSizeOfImg = isImageWidthSpecified ? imgQuery[size]?.width || imgQuery[size] : this.getImageWidthFromScreenSize(media);
      const currentSizeImgUrl = imgQuery && imgQuery[size]?.url ? imgQuery[size].url : imageUrl;
      return {
        media,
        srcset: this.convertImgUrlToSrcSet(currentSizeImgUrl, defaultSizeOfImg, media, imgParam),
      };
    });
  }

  public convertImgUrlToSrcSet(imageUrl: string, defaultSize: number, screenSize: Screen, imgParam?: string): string {
    const image1xUrl = `${imageUrl}?im=Resize=(${defaultSize})`;
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const image2xUrl = `${imageUrl}?im=Resize=(${defaultSize * 2})`;
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const image3xUrl = `${imageUrl}?im=Resize=(${defaultSize * 3})`;

    if (imgParam) {
      return screenSize === Screen.XS
        ? `${image1xUrl}${imgParam}, ${image2xUrl}${imgParam} 2x, ${image3xUrl}${imgParam} 3x`
        : `${image1xUrl}${imgParam}, ${image2xUrl}${imgParam} 2x`;
    }

    return screenSize === Screen.XS ? `${image1xUrl}, ${image2xUrl} 2x, ${image3xUrl} 3x` : `${image1xUrl}, ${image2xUrl} 2x`;
  }

  public getImageWidthFromScreenSize(screen: Screen): number {
    const breakpoint = Object.entries(Screen).find(([k, v]) => v === screen)?.[0];
    return screenImageWidths[breakpoint];
  }
}
